import { DeliveryModel, Journey } from '@audibene/ta.utils-opportunity'
import { Country } from '../../constants'
import { getDeliveryModelFromJourney } from '../../util/getDeliveryModelFromJourney'

/**
 * True when the given journey/country combination is a US Teleaudiology context.
 *
 * Used to scope trial-status gating (PX-1807/PX-3311) to US + Teleaudiology only -
 * non-US or non-Teleaudiology customers are never affected by that gating.
 */
const useIsUsTeleaudiologyContext = (journey?: Journey, country?: Country): boolean =>
  country === Country.US && getDeliveryModelFromJourney(journey) === DeliveryModel.TELEAUDIOLOGY

export { useIsUsTeleaudiologyContext }
